import config from "../config";

export const DEFAULT_PAGE_SIZE = config.defaultPageSize;

export const DEFAULT_DEBOUNCE_DELAY = 300;
